import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const merchItems = [{
  name: 'Palabras T-Shirt',
  price: 15
}, {
  name: 'HOPE Mug',
  price: 12
}, {
  name: 'Canvas Tote Bag',
  price: 10
}, {
  name: 'Logo Sticker',
  price: 1
}, {
  name: 'Travel Tumbler',
  price: 20
}];
export function Merch() {
  return <section id="merch" className="py-24 bg-hope-teal text-white overflow-hidden" data-id="element-140">
      <div className="max-w-7xl mx-auto px-6" data-id="element-141">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-143">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-hope-cream" data-id="element-144">
              Wear the Mission.
            </h2>
            <p className="text-lg text-white/80 mb-10 leading-relaxed max-w-md" data-id="element-145">
              Take a piece of HOPE home with you. 100% of proceeds from our
              merchandise directly support the Centro Comunitario Palabras de
              Esperanza.
            </p>

            <div className="space-y-4" data-id="element-146">
              {merchItems.map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + idx * 0.1
            }} className="flex justify-between items-center p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 hover:bg-white/20 transition-colors" data-id="element-147">
                  <div className="flex items-center gap-4" data-id="element-148">
                    <div className="w-10 h-10 rounded-full bg-hope-mustard/20 flex items-center justify-center text-hope-mustard" data-id="element-149">
                      <ShoppingBag size={18} data-id="element-150" />
                    </div>
                    <span className="font-medium text-lg" data-id="element-151">{item.name}</span>
                  </div>
                  <span className="font-serif text-xl text-hope-mustard font-bold" data-id="element-152">
                    ${item.price}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-full min-h-[400px] lg:min-h-[600px]" data-id="element-153">
            <div className="absolute inset-0 bg-hope-mustard/20 rounded-3xl transform rotate-3" data-id="element-154"></div>
            <img src="https://cdn.magicpatterns.com/uploads/spzxZYQviFPuYq35d3jdK3/IMG_9573.jpg" alt="HOPE Merch Shelf" className="absolute inset-0 w-full h-full object-cover rounded-2xl shadow-2xl" data-id="element-155" />
          </motion.div>
        </div>
      </div>
    </section>;
}